// Typography as per Huballas design

import styled from "styled-components";

export const colors = {
    text: "#3e5660",

    backgroundLevel1: "#ffffff",
    backgroundLevel2: "#f3f6f8",
    backgroundLevel3: "#e9eef2",
    backgroundLevel4: "#e9f7f7",

    tableBorder: "#EFEFEF",

    separator: "#d5dde3",

    primary: "#009a96",
    primaryLight: "#4d9d88",
    primaryAction: "#d5121e",
    primaryHover: "#3e5660",

    secondaryHover: "#71828e",
    secondaryAction: "#3e5660",

    disabled: "#b3b3b3",
    breadcrumb: "#7d8699",
};

export const H1 = styled.h1`
    margin: 0;
    padding: 0;

    font-size: 3rem;
    font-style: normal;
    font-weight: 700;
    line-height: 2.5rem;
    color: ${colors.text};
`;

export const H2 = styled.h2`
    margin: 0;
    padding: 0;

    font-size: 2rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2rem;
    color: ${colors.text};
`;

export const H3 = styled.h3`
    margin: 0;
    padding: 0;

    font-size: 1.5rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem;
    color: ${colors.text};
`;

export const H4 = styled.h4`
    margin: 0;
    padding: 0;

    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
    color: ${colors.text};
`;

export const Paragraph = styled.p`
    margin: 0;
    padding: 0;

    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem;
    color: ${colors.text};
`;

export const Label = styled.div`
    margin: 0;
    padding: 0;

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1rem;
    color: ${colors.text};
`;

// Button
interface ButtonProps {
    variant?: "primary" | "secondary";
}

export const Button = styled.button<ButtonProps>`
    margin: 0;
    padding: 0;

    display: inline-flex;
    align-items: center;
    gap: 0.5rem;

    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;

    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;

    ${({ variant = "primary" }) =>
        variant === "primary"
            ? `
        color: ${colors.primaryAction};
        border: none;

        &:hover {
            background-color: ${colors.primaryHover};
        }
    `
            : `
        background-color: transparent;
        color: ${colors.secondaryAction};
        border: 1px solid ${colors.secondaryAction};

        &:hover {
            color: ${colors.secondaryHover};
        }
    `}

    &:disabled {
        background-color: ${colors.disabled};
        cursor: not-allowed;
        border: none;
    }
`;
